import { render, staticRenderFns } from "./sysMenuManagement.vue?vue&type=template&id=3700ccf0"
import script from "./sysMenuManagement.vue?vue&type=script&lang=js"
export * from "./sysMenuManagement.vue?vue&type=script&lang=js"
import style0 from "./sysMenuManagement.vue?vue&type=style&index=0&id=3700ccf0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports